import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const PlugsIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path d="M13.012 13.248a.85.85 0 0 1 1.202 1.203l-2.41 2.409 3.34 3.339 2.409-2.409a.85.85 0 0 1 1.202 1.203l-2.41 2.407.938.937a.85.85 0 0 1 0 1.202l-2.204 2.203a6.237 6.237 0 0 1-8.174.56l-3.45 3.45-.064.058a.851.851 0 0 1-1.073 0l-.065-.058a.85.85 0 0 1 0-1.202l3.45-3.45a6.23 6.23 0 0 1 .56-8.17l2.205-2.203a.85.85 0 0 1 1.202 0l.932.932 2.41-2.41Zm-5.546 4.883a4.53 4.53 0 0 0-.008 6.402l.008.008.008.006a4.534 4.534 0 0 0 6.403-.006l1.604-1.603-6.412-6.41-1.603 1.603ZM28.509 2.256a.876.876 0 0 1 1.238 1.239L26.193 7.05a6.425 6.425 0 0 1-.579 8.422l-2.27 2.27a.877.877 0 0 1-1.24 0l-7.843-7.844a.876.876 0 0 1 0-1.238l2.27-2.27a6.424 6.424 0 0 1 8.422-.578l3.556-3.556Zm-4.133 5.371a4.672 4.672 0 0 0-6.606 0L16.118 9.28l6.607 6.606 1.651-1.651a4.672 4.672 0 0 0 0-6.607Z" />
    </BaseIcon>
  );
};
